module.exports = {
    MANIFEST_NAME: "Elemental.TV",
    MANIFEST_SHORT_NAME: "Elemental.TV"
};
